module.exports = __webpack_public_path__ + "img/kommune-1859.8eb6fa65.svg";